import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "./typeDefinitionAttribute";
import { ContaminationDeclarationValidityFields } from "./contaminationDeclarationValidity";

// Full declaration as the editor needs it. Both mutations return the same
// shape, so a save needs no second round trip for validity / warnings.
// Deliberately without `file`: its presigned link is user-bound and expires
// after an hour, and `File` is a normalized, cross-query entity — the print
// link is fetched on demand instead (ContaminationDeclarationPrintFile).
export const ContaminationDeclarationFields = gql`
    fragment ContaminationDeclarationFields on ContaminationDeclaration {
        id
        insert
        update
        templateKey
        templateVersion
        installedBaseEventId
        assetId
        productModelName
        serialNumber
        productCode
        installedBaseNodeId
        installedBaseNodePath
        updatedAt
        updatedBy {
            id
            name
        }
        runningTimeHours
        invoiceNumber
        purchaseOrderNumber
        reasonForService
        returnForTestingOnly
        equipmentWasUsed
        oilType
        decontaminated
        contaminationBiological
        contaminationExplosive
        contaminationRadioactive
        contaminationMercuryCyanideDioxinsSodiumAzidePcbs
        contaminationArsenicCadmiumPhosphorous
        contaminationCopperProcess
        contaminationToxic
        contaminationCorrosive
        contaminationPyrophoric
        contaminationOther
        substances {
            id
            position
            chemical
            dangerClass
            risks
            firstAid
        }
        substancesAdditionalInformation
        billingAddress
        shippingAddress
        technicianName
        technicianPhone
        technicianEmail
        declarationAccepted
        validity {
            ...ContaminationDeclarationValidityFields
        }
        warningList {
            code
            attributeIndex
            message
        }
        typeDefinitionAttributeList {
            typeDefinitionAttributes {
                ...TypeDefinitionAttributeFields
            }
        }
    }
    ${ContaminationDeclarationValidityFields}
    ${TypeDefinitionAttributeFields}
`;
